import React, { useEffect, useState } from 'react'
import ym from 'react-yandex-metrika'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import './style.css'

import PP from '../../assets/images/projects/pp.jpg'
import PPOnHover from '../../assets/images/projects/on_hover_pp.mov'

import P from '../../assets/images/projects/p.png'
import POnHover from '../../assets/images/projects/on_hover_p.png'

import JV from '../../assets/images/projects/jv.png'
import JVOnHover from '../../assets/images/projects/on_hover_jv.mov'

import Al from '../../assets/images/projects/al.png'
import AlOnHover from '../../assets/images/projects/on_hover_al.mov'

import Ig from '../../assets/images/projects/ig.png'
import IgOnHover from '../../assets/images/projects/on_hover_ig.mov'

import Tommy from '../../assets/images/projects/tommy.png'
import TommyOnHover from '../../assets/images/projects/on_hover_tommy.mov'

import DS from '../../assets/images/projects/ds.png'
import DSOnHover from '../../assets/images/projects/on_hover_ds.mov'

import MU from '../../assets/images/projects/mu.png'
import MUOnHover from '../../assets/images/projects/on_hover_mu.png'

import DM from '../../assets/images/projects/dm.png'
import DMOnHover from '../../assets/images/projects/on_hover_dm.mov'

import AA from '../../assets/images/projects/aa.png'
import AAOnHover from '../../assets/images/projects/on_hover_aa.png'

const projects = [
    {
        name: 'Tommy',
        isBig: true,
        background: Tommy,
        link: 'tommy',
        onHover: TommyOnHover
    },
    {
        name: 'Медюнион',
        isBig: false,
        link: 'medunion',
        background: MU,
        notVideo: MUOnHover,
        animation: 'pulse'
    },
    {
        name: 'PlusPatch',
        isBig: false,
        link: 'pluspatch',
        background: PP,
        onHover: PPOnHover
    },
    {
        name: 'Direct Scouting Center',
        isBig: false,
        background: DS,
        link: 'direct-scouting-center',
        onHover: DSOnHover
    },
    {
        name: 'ДомАвтоматика',
        isBig: false,
        background: DM,
        link: 'domautomatika',
        onHover: DMOnHover
    },
    {
        name: 'AutoAzart',
        isBig: true,
        background: AA,
        notVideo: AAOnHover
    },
    {
        name: 'Jenya Vyguzov',
        isBig: false,
        background: JV,
        onHover: JVOnHover,
        href: 'https://jenyavyguzov.com'
    },
    {
        name: 'Ингуд - страхование',
        isBig: false,
        background: Ig,
        onHover: IgOnHover,
        href: 'https://ingood.group'
    },
    {
        name: 'Альтаир',
        isBig: false,
        background: Al,
        onHover: AlOnHover,
        href: 'http://альтаирспец.рф'
    },
    {
        name: 'Покровский',
        isBig: false,
        background: P,
        notVideo: POnHover,
        href: 'https://autopokrov.ru'
    }
]

const OurWorks = ({ t }) => {

    const [size, setSize] = useState({
        width: 0,
        height: 0
    })

    useEffect(() => {
        ym('hit', '/our-works')
        const width = document.body.clientWidth - 15
        if(width <= 768) {
            setSize({
                width: width,
                height: width / 2
            })
        } else {
            setSize({
                width: width / 2,
                height: width / 4
            })
            console.log(width, size)
        }
    }, [])

    const onMouseOver = (e) => {
        const { currentTarget } = e
        const image = currentTarget.firstChild
        const video = currentTarget.childNodes[1]

        image.style.opacity = 0

        if(video && typeof video.play === 'function') {
            video.play()
        } else {

        }
    }

    const onMouseOut = (e) => {
        const { currentTarget } = e
        const image = currentTarget.firstChild
        const video = currentTarget.childNodes[1]

        image.style.opacity = 1

        if(video && typeof video.load === 'function')
            video.pause()
    }

    const LinkWrapper = ({ to, href, children }) => {
        console.log(typeof to, href)
        return !to && href
            ? <a href={ `${ href }` } target="_blank" rel="nofollow noopener noreferrer">{ children }</a>
            : <Link to={ to ? `/our-works/${ to }` : "#" }>{ children }</Link>
    }

    return (
        <main className="app__content--ourworks">
            <Helmet>
                <title>{ t('Our Works') }</title>
            </Helmet>
            <div id="grid" className="grid">
                {
                    projects.map(({ background, isBig, link, image, name, onHover, notVideo, animation, href }, i) => (
                        <LinkWrapper key={ `${i}_project` } to={ link } href={ href }>
                            <div
                                style={ isBig ? { height: size.height, width: size.width, background } : { height: size.height, width: size.height, background } }
                                onMouseOver={ onMouseOver } onMouseOut={ onMouseOut }
                                className="app__content--block">
                                {
                                    image ? (
                                        <img src={ image } alt={ name } className="app__content--block-image" />
                                    )  : (
                                        <img
                                            src={ background }
                                            alt={ name }
                                            style={ isBig ? { height: size.height, width: size.width } : { height: size.height, width: size.height } }
                                            className="app__content__abs" />
                                    )
                                }
                                {
                                    onHover ? (
                                        <video width="100%" height="100%" className="video" playsInline muted loop preload="true">
                                            <source src={ onHover } type="video/mp4" />
                                        </video>
                                    ) : notVideo ? (
                                        <img src={ notVideo } alt={ name } className={ animation } style={ isBig ? { height: size.height, width: size.width } : { height: size.height, width: size.height } } />
                                    ) : null
                                }
                                <div className="app__content--block-over"  />
                            </div>
                        </LinkWrapper>
                    ))
                }
            </div>
        </main>
    )

}

export default translate('translations')(OurWorks)



// WEBPACK FOOTER //
// ./src/Pages/OurWorks/index.js